import React, { Component, Fragment, pureComponent } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import Keyboard from '../keyboard/keyboardInput';
import { get } from 'lodash';
import { numberFormat } from '../../common';
class Coeff extends Component {

  cfDiv = React.createRef();

  componentDidUpdate(nextProps) {
    this.cfDiv.current.classList.remove('b_u', 'b_d');
    if (nextProps.id === this.props.id) {
      if (nextProps.cf != this.props.cf) {
        nextProps.cf > this.props.cf ? this.animate('b_d') : this.animate('b_u');
      }
    }
  }

  animate = (a) => {
    if (this.cfDiv.current) {
      this.cfDiv.current.classList.add(a);
    }
  }

  render() {
    return (
      <div ref={this.cfDiv} className="basket-item-cf basket-item-coefficient">{numberFormat(this.props.cf, 2, ',', ' ')}</div>
    )
  }
}

@withRouter
@inject('lineStore', 'dictStore', 'accountStore')
@observer
class Odd extends Component {

  componentWillReceiveProps(nextProps) {
    if (get(this.basketItem, 'classList')) {
      this.basketItem.classList.remove('animate');
      if (nextProps.odd != this.props.odd || nextProps.cf != this.props.cf) {
        this.basketItem.classList.add('animate');
      }
    }
  }

  handleRemove = () => {
    this.props.lineStore.basket.newDeleteOdd(this.props.id);
  }

  handleChange = (e) => {
    this.props.lineStore.basket.newOnOrdinarAmountInput(e, this.props.id);
  }

  route = () => {
    this.props.history.push(`/${this.props.lineStore.basket.mode}/${this.props.lineStore.basket.basketData.odds[this.props.id].sportId}/${this.props.lineStore.basket.basketData.odds[this.props.id].championshipId}/${this.props.lineStore.basket.basketData.odds[this.props.id].matchId}`);
  }

  render() {
    const { basketPosition } = this.props.accountStore.accountSettings;
    const { type, oneClick, successBet } = this.props.lineStore.basket;
    // const { status } = this.props.lineStore.basket.odds.get(this.props.id);
    const basketData = this.props.lineStore.basket.basketData;
    const odds = get(basketData, [`odds`, this.props.id])
    const team1 = get(odds, 'team1')
    const team2 = get(odds, 'team2')
    const cf = get(odds, 'cf')
    const txt = get(odds, 'txt')
    const name = get(odds, 'name')
    const amount = get(odds, 'amount')
    const championship = get(odds, 'championship')
    const sportId = get(odds, 'sportId')
    const url = get(odds, 'url')
    const bet = get(odds, 'bet')
    const matchId = get(odds, 'matchId')
    const minBetSum = get(basketData, 'min')
    const maxBetSum = get(odds, 'max')
    const minVip = get(odds, 'minVip')
    const isVipBet = get(basketData, 'isVipBet')

    if (!cf) {
      return null
    }
    const { getLang } = this.props.dictStore;

    return (
      <div className="basket-item animate" ref={(el) => { this.basketItem = el }}>
        <div className="basket-item-p1">
          <div className="basket-item-remove">
            <div className="basket-item-remove_icon" onClick={this.handleRemove}>×</div>
          </div>
          <div className="fl_r basket-item-coef">
            {/* <Coeff cf={cf_ws || cf} id={id} gid={this.props.id} /> */}
            <Coeff cf={cf} id={this.props.id} gid={matchId} />
          </div>
          <div onClick={this.route} className="basket-item-event" title={`${team1}${team2 ? ' - ' + team2 : ''}`}>{`${team1}${team2 ? ' - ' + team2 : ''}`}</div>
        </div>
        <div className="basket-item-p2 clearfix">
          <div className="basket-item-name fl_l" title={txt} >{txt}</div>
          {/* status == 0  */}
          {basketData.betType === 1 && !oneClick.st ?
            <div className="basket-item-sum fl_r">
              {/* <input
                id={`bet_${id}`}
                onChange={this.handleChange}
                type="text"
                className="fl_r"
                placeholder="Сумма"
                ref={input => this.amountInput = input}
                value={amount ? amount : ''}
              />*/}
              <Keyboard
                id={`bet_${this.props.id}`}
                type="text"
                className="fl_r"
                placeholder={ isVipBet ? `${getLang('MIN')} ${minVip}` : `${minBetSum} - ${maxBetSum}` }
                maxLength={10}
                onChange={this.handleChange}
                value={amount ? amount : ''}
                autoComplete="off"
                positionX={basketPosition == "left" ? 'right' : 'left'}
                positionY="bottom"
              />
            </div>
            : ''}
        </div>
        <div className="clearfix"></div>
        <div className="basket-item-p3">
          {basketData.odds[this.props.id].text && basketData.odds[this.props.id].isOddSuccessRequest ? (
            <div id={`bet_result_${this.props.id}`} className="basket-item-result">
              {getLang(basketData.odds[this.props.id].text)}
            </div>
          ) : (
            <div
              id={`bet_error_${this.props.id}`}
              className="basket-item-error"
              dangerouslySetInnerHTML={{ __html: getLang(basketData.odds[this.props.id].text) }}
            />
          )}
        </div>
      </div>
    )
  }
}

export default function Odds({ odds = {}, oddsIds = new Set() }) {

  let orderedOdds = []
  oddsIds.forEach(oddId => {
    if (!get(odds[oddId], 'cf')) {
      return
    }
    orderedOdds = [...orderedOdds, <Odd key={`basket_item_${oddId}`} id={oddId} odd={odds[oddId]} cf={odds[oddId].cf} />]
  })

  return (
    <Fragment>
      {
        orderedOdds.length ? (<div className="basket-bets">
          {orderedOdds}
        </div>) : ''
      }
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/components/basket/items.js